import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { RequestObserverService } from 'src/app/core/services/common/request-observer.service';

@Component({
  selector: 'app-stateful-primary-button',
  templateUrl: './stateful-primary-button.component.html',
  styleUrls: ['./stateful-primary-button.component.scss'],
})
export class StatefulPrimaryButtonComponent implements OnInit {
  @Input() text: string;
  @Input() pageUrl: string;
  @Input() stateId: string;
  @Input() clickEvent: () => Promise<boolean>;
  @Input() colorCssClass: 'orange' | '' | undefined = '';
  @Input() fontSizeCssClass: 'extra-large' | '' | undefined = '';
  @Input() textPropsCssClass: 'text-props' | '' | undefined = '';
  @Input() bypassNav = false;
  selected = false;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'secondary',
    size: <LoaderSize>'small',
  };

  constructor(
    private router: Router,
    private requestObserver: RequestObserverService
  ) {}

  ngOnInit(): void {
    if (this.colorCssClass === 'orange')
      this.loader.themeColor = <LoaderThemeColor>'primary';
  }

  // Submit method from the component which is using StatefulPrimaryButtonComponent should be returned true or false to prevent the page from navigating
  async submit(): Promise<boolean> {
    if (!this.requestObserver.isAcceptingRequest()) return false;
    this.requestObserver.beginRequest();
    this.selected = true;

    if (this.clickEvent !== undefined) {
      const response = await this.clickEvent()
        .then((res: boolean) => res)
        .catch((exception) => {
          this.selected = false;
          this.requestObserver.endRequest();
          return false;
        });
      if (!response) {
        this.selected = false;
        this.requestObserver.endRequest();
        return response;
      }
    }

    if (!this.bypassNav) {
      await this.navigate({ pageUrl: this.pageUrl, id: this.stateId });
    }

    this.requestObserver.endRequest();
    if (this.selected === true)
      setTimeout(() => {
        this.selected = false;
      }, 1500);
    return true;
  }

  async navigate(pageState: any) {
    await this.router.navigate([pageState.pageUrl], {
      queryParams: { stateId: pageState.id },
    });
  }
}
